export default "__VITE_ASSET__7d601ddf__"